import I18nProvider, { type I18nProviderProps } from "@cloudscape-design/components/i18n";
import type { PropsWithChildren } from "react";

const viMessages: I18nProviderProps.Messages = {
  "cloudscape-design-components": {
    vi: {
      alert: {
        dismissAriaLabel: "Đóng thông báo",
        "i18nStrings.dismissAriaLabel": "Đóng thông báo",
        "i18nStrings.errorIconAriaLabel": "Lỗi",
        "i18nStrings.infoIconAriaLabel": "Thông tin",
        "i18nStrings.successIconAriaLabel": "Thành công",
        "i18nStrings.warningIconAriaLabel": "Cảnh báo",
      },
      "app-layout": {
        "ariaLabels.drawers": "Các ngăn phụ",
        "ariaLabels.drawersOverflow": "Các ngăn phụ khác",
        "ariaLabels.drawersOverflowWithBadge": "Các ngăn phụ khác có cập nhật",
        "ariaLabels.navigation": "Điều hướng FaceGo",
        "ariaLabels.navigationClose": "Đóng điều hướng",
        "ariaLabels.navigationToggle": "Mở điều hướng",
        "ariaLabels.notifications": "Thông báo",
        "ariaLabels.tools": "Bảng công cụ",
        "ariaLabels.toolsClose": "Đóng bảng công cụ",
        "ariaLabels.toolsToggle": "Mở bảng công cụ",
      },
      autosuggest: {
        errorIconAriaLabel: "Lỗi",
        recoveryText: "Thử lại",
        selectedAriaLabel: "Đã chọn",
      },
      "breadcrumb-group": { expandAriaLabel: "Hiện đầy đủ đường dẫn" },
      button: { "i18nStrings.externalIconAriaLabel": "Mở trong thẻ mới" },
      calendar: {
        nextMonthAriaLabel: "Tháng sau",
        previousMonthAriaLabel: "Tháng trước",
        todayAriaLabel: "Hôm nay",
        "i18nStrings.currentMonthAriaLabel": "Tháng hiện tại",
        "i18nStrings.nextYearAriaLabel": "Năm sau",
        "i18nStrings.previousYearAriaLabel": "Năm trước",
      },
      cards: { "ariaLabels.selectionGroupLabel": "Chọn mục" },
      "collection-preferences": {
        cancelLabel: "Hủy",
        confirmLabel: "Xác nhận",
        title: "Tùy chọn hiển thị",
        "contentDensityPreference.description": "Hiển thị nhiều dữ liệu hơn trong cùng không gian.",
        "contentDensityPreference.label": "Chế độ gọn",
        "contentDisplayPreference.description": "Chọn cột và thứ tự hiển thị.",
        "contentDisplayPreference.dragHandleAriaDescription": "Nhấn Space hoặc Enter để bắt đầu kéo, dùng phím mũi tên để đổi vị trí, sau đó nhấn Space hoặc Enter để xác nhận; nhấn Escape để hủy.",
        "contentDisplayPreference.dragHandleAriaLabel": "Tay nắm kéo cột",
        "contentDisplayPreference.i18nStrings.columnFilteringAriaLabel": "Lọc danh sách cột",
        "contentDisplayPreference.i18nStrings.columnFilteringClearFilterText": "Xóa bộ lọc",
        "contentDisplayPreference.i18nStrings.columnFilteringNoMatchText": "Không có cột phù hợp",
        "contentDisplayPreference.i18nStrings.columnFilteringPlaceholder": "Tìm cột",
        "contentDisplayPreference.liveAnnouncementDndDiscarded": "Đã hủy sắp xếp lại",
        "contentDisplayPreference.liveAnnouncementDndGroupLabel": "{label}, {count} mục",
        "contentDisplayPreference.liveAnnouncementDndItemCommitted": "Đã chuyển mục từ vị trí {initialPosition} sang {finalPosition} trên tổng số {total}",
        "contentDisplayPreference.liveAnnouncementDndItemReordered": "Đã chuyển mục đến vị trí {currentPosition} trên tổng số {total}",
        "contentDisplayPreference.liveAnnouncementDndStarted": "Đã chọn mục ở vị trí {position} trên tổng số {total}",
        "contentDisplayPreference.title": "Cột hiển thị",
        "pageSizePreference.title": "Số dòng mỗi trang",
        "stickyColumnsPreference.firstColumns.description": "Giữ các cột đầu tiên khi cuộn ngang.",
        "stickyColumnsPreference.firstColumns.options[0].label": "Không ghim",
        "stickyColumnsPreference.firstColumns.options[1].label": "Cột đầu tiên",
        "stickyColumnsPreference.firstColumns.options[2].label": "Hai cột đầu tiên",
        "stickyColumnsPreference.firstColumns.title": "Ghim cột đầu",
        "stickyColumnsPreference.lastColumns.description": "Giữ cột cuối cùng khi cuộn ngang.",
        "stickyColumnsPreference.lastColumns.options[0].label": "Không ghim",
        "stickyColumnsPreference.lastColumns.options[1].label": "Cột cuối cùng",
        "stickyColumnsPreference.lastColumns.title": "Ghim cột cuối",
        "stripedRowsPreference.description": "Dùng màu nền xen kẽ giữa các dòng.",
        "stripedRowsPreference.label": "Dòng xen kẽ",
        "wrapLinesPreference.description": "Hiển thị đầy đủ nội dung dài trên nhiều dòng.",
        "wrapLinesPreference.label": "Xuống dòng",
      },
      "copy-to-clipboard": { "i18nStrings.copyButtonText": "Sao chép" },
      "date-picker": {
        "i18nStrings.openCalendarAriaLabel": "Chọn ngày; ngày đang chọn là {selectedDate}",
      },
      drawer: { "i18nStrings.loadingText": "Đang tải nội dung" },
      "error-boundary": {
        "i18nStrings.headerText": "Không hiển thị được phần này",
        "i18nStrings.descriptionText": "Đã xảy ra lỗi ngoài dự kiến. Tải lại trang để thử lại.",
        "i18nStrings.refreshActionText": "Tải lại",
      },
      flashbar: {
        "i18nStrings.ariaLabel": "Thông báo",
        "i18nStrings.errorIconAriaLabel": "Lỗi",
        "i18nStrings.inProgressIconAriaLabel": "Đang xử lý",
        "i18nStrings.infoIconAriaLabel": "Thông tin",
        "i18nStrings.notificationBarAriaLabel": "Tất cả thông báo",
        "i18nStrings.notificationBarText": "Thông báo",
        "i18nStrings.successIconAriaLabel": "Thành công",
        "i18nStrings.warningIconAriaLabel": "Cảnh báo",
      },
      form: { errorIconAriaLabel: "Lỗi" },
      "form-field": {
        "i18nStrings.errorIconAriaLabel": "Lỗi",
        "i18nStrings.warningIconAriaLabel": "Cảnh báo",
      },
      "help-panel": { loadingText: "Đang tải nội dung trợ giúp" },
      input: { clearAriaLabel: "Xóa nội dung" },
      link: { externalIconAriaLabel: "Mở trong thẻ mới" },
      modal: { closeAriaLabel: "Đóng hộp thoại" },
      multiselect: {
        deselectAriaLabel: "Bỏ chọn {option__label}",
        "i18nStrings.selectAllText": "Chọn tất cả",
      },
      pagination: {
        "ariaLabels.jumpToPageButtonLabel": "Chuyển đến trang",
        "ariaLabels.nextPageLabel": "Trang tiếp theo",
        "ariaLabels.pageLabel": "Trang {pageNumber}",
        "ariaLabels.previousPageLabel": "Trang trước",
        "i18nStrings.jumpToPageError": "Nhập số trang hợp lệ",
        "i18nStrings.jumpToPageInputLabel": "Số trang",
        "i18nStrings.jumpToPageLoadingText": "Đang chuyển trang",
      },
      popover: { dismissAriaLabel: "Đóng nội dung bật lên" },
      select: {
        errorIconAriaLabel: "Lỗi",
        recoveryText: "Thử lại",
        selectedAriaLabel: "Đã chọn",
      },
      table: {
        "ariaLabels.collapseButtonLabel": "Thu gọn",
        "ariaLabels.expandButtonLabel": "Mở rộng",
        "ariaLabels.liveAnnouncementSortCleared": "Đã bỏ sắp xếp bảng",
        "ariaLabels.liveAnnouncementSortOrder": "Bảng được sắp xếp theo {columns}",
        "ariaLabels.resizerRoleDescription": "Nút thay đổi độ rộng cột",
        "ariaLabels.sortMenuTriggerLabel": "Tùy chọn sắp xếp",
        "ariaLabels.sortPriority": "Ưu tiên sắp xếp {priority}",
        "ariaLabels.sortAscending": "tăng dần",
        "ariaLabels.sortDescending": "giảm dần",
        "ariaLabels.submittingEditText": "Đang lưu chỉnh sửa",
        "ariaLabels.successfulEditLabel": "Đã lưu chỉnh sửa",
        "columnDefinitions.editConfig.editIconAriaLabel": "Có thể chỉnh sửa",
        "columnDefinitions.editConfig.errorIconAriaLabel": "Lỗi chỉnh sửa",
        "i18nStrings.clearSort": "Bỏ sắp xếp",
        "i18nStrings.sortDropdownAddToSortAscending": "Thêm sắp xếp tăng dần",
        "i18nStrings.sortDropdownAddToSortDescending": "Thêm sắp xếp giảm dần",
        "i18nStrings.sortDropdownAddToSortDisabledReason": "Cột này đã được sắp xếp",
        "i18nStrings.sortDropdownMultiColumnSortGroup": "Sắp xếp nhiều cột",
        "i18nStrings.sortDropdownRemoveFromSort": "Bỏ cột khỏi sắp xếp",
        "i18nStrings.sortDropdownRemoveFromSortDisabledReason": "Cột này chưa được sắp xếp",
        "i18nStrings.sortDropdownSortAscending": "Sắp xếp tăng dần",
        "i18nStrings.sortDropdownSortDescending": "Sắp xếp giảm dần",
      },
      tabs: {
        "i18nStrings.scrollLeftAriaLabel": "Cuộn tab sang trái",
        "i18nStrings.scrollRightAriaLabel": "Cuộn tab sang phải",
        "i18nStrings.tabsWithActionsAriaRoleDescription": "Nhóm tab có thao tác",
      },
      "top-navigation": {
        "i18nStrings.overflowMenuBackIconAriaLabel": "Quay lại",
        "i18nStrings.overflowMenuDismissIconAriaLabel": "Đóng menu",
        "i18nStrings.overflowMenuTitleText": "Tất cả",
        "i18nStrings.overflowMenuTriggerText": "Thêm",
        "i18nStrings.searchDismissIconAriaLabel": "Đóng tìm kiếm",
        "i18nStrings.searchIconAriaLabel": "Tìm kiếm",
      },
      wizard: {
        "i18nStrings.cancelButton": "Hủy",
        "i18nStrings.collapsedStepsLabel": "Bước {stepNumber} trên {stepsCount}",
        "i18nStrings.navigationAriaLabel": "Các bước",
        "i18nStrings.nextButton": "Tiếp theo",
        "i18nStrings.nextButtonLoadingAnnouncement": "Đang tải bước tiếp theo",
        "i18nStrings.optional": "không bắt buộc",
        "i18nStrings.previousButton": "Quay lại",
        "i18nStrings.skipToButtonLabel": "Chuyển đến {task__title}",
        "i18nStrings.stepNumberLabel": "Bước {stepNumber}",
        "i18nStrings.submitButtonLoadingAnnouncement": "Đang gửi biểu mẫu",
      },
    },
  },
};

export function FaceGoI18nProvider({ children }: PropsWithChildren) {
  return <I18nProvider locale="vi" messages={[viMessages]}>{children}</I18nProvider>;
}
